import React, { Component } from 'react';

import NavBar from "../navbar/NavBar"
import Footer from "../footer/Footer"
import { JOBS } from './Jobs_data';

class Jobs extends Component {
    constructor(props) {
        super(props);
        this.path = '/jobs';
        this.state = {
            jobs: JOBS
        };
    }

    expandJob = (index) => {
        this.state.jobs[index].expanded = !this.state.jobs[index].expanded;
        this.setState({
            jobs: this.state.jobs
        });
    }

    render() {
        return (
            <div>
                <NavBar path={this.path} />
                <div className="container1">
                    <div className="row">
                        <div className="col-sm-3 sidebar"></div>
                        <div className="col-sm-7">
                            <p className="title" style={{ fontSize: "30px" }}><b>SDNI Job Bulletin Board</b></p>
                            <p><b className="programs-span">DISCLAIMER:</b> This job posting section is intended to be a service to our institutional users and individuals seeking jobs to include, without limitation, students and postdocs. Please be aware that the posting of an employment opportunity on this webpage does not constitute an endorsement of such employment opportunity by UC San Diego, the Qualcomm Institute, Nano3, or the San Diego Nanotechnology Infrastructure.</p>
                            <p>For Job Opportunities with UCSD, including all SDNI facilities (e.g. Nano3), please search postings at:&nbsp;
                                <a href="https://employment.ucsd.edu/" className="bold-blue">Careers at UC San Diego</a></p><br />
                            <p><b className="programs-span">Institutional users: To post a job, please proceed as follows:</b><br />
                                Send an email to Yves Theriault at <a href={"mailto:ytheriault@ucsd.edu"} className="bold-blue">ytheriault@ucsd.edu</a> with the following info:<br />
                                1. A complete Job Title<br />
                                2. Complete name of your Company (include Inc., LLC and the like if any)<br />
                                3. Provide <span className="bold-blue">ONE</span> of the following:<br />
                                &emsp;1. A link to your own website for applicant to apply directly with you; <span className="bold-blue">OR</span><br />
                                &emsp;2. A job description in the core of your email AND the name of the contact person <span className="bold-blue">AND</span> contact person’s email address where applicant can send their resumes; <span className="bold-blue">OR</span><br />
                                &emsp;3. An email attachment containing the job description <span className="bold-blue">AND</span> the name of the contact person <span className="bold-blue">AND</span> contact person’s email address where applicant can send their resumes<br />
                                <br />
                                <b className="programs-span">The deadline for submitting a Job Opportunity is 6 pm on Thursday of the preceding week for Monday postings.
                                    Posting a job on our billboard is free of charge and we are happy to bring this valuable tool to our users.</b></p><br />

                            <table>
                                <tbody>
                                    {
                                        this.state.jobs.map((job, index) =>
                                            job.has_url ?
                                                <tr>
                                                    <td width="10%" className="text">
                                                        <h className="job-title">{job.title}</h>
                                                        <br />
                                                        <h className="job-company">{job.company}</h>
                                                        <br />
                                                        <h className="job-date">{"Posted on " + job.date}</h>
                                                        <br />
                                                        <a href={job.description} target="_blank" className="job-btn">View
                                                        Description and Apply >>></a>
                                                    </td>
                                                </tr>
                                                :
                                                <tr>
                                                    <td width="10%" className="text">
                                                        <h className="job-title">{job.title}</h>
                                                        <br />
                                                        <h className="job-company">{job.company}</h>
                                                        <br />
                                                        <h className="job-date">{"Posted on " + job.date}</h>
                                                        <br /><br style={{ display: job.expanded ? "block" : "none" }} />

                                                        {job.description.split("\n").map((item, idx) => (
                                                            <p style={{ display: job.expanded ? "block" : "none"}} className="job-description">{item}</p>
                                                        ))}
                                                        {/*<p style={{display: job.expanded ? "block" : "none"}} className="job-description">{job.description}</p>*/}

                                                        <p style={{ display: job.expanded && job.POC && job.email ? "inline-block" : "none", fontWeight: "bold" }} className="job-description">To apply, please email&nbsp;</p>
                                                        <p style={{ display: job.expanded && job.POC && job.email ? "inline-block" : "none", fontWeight: "bold", color: "#3b74ec" }} className="job-description">{job.POC}</p>
                                                        <p style={{ display: job.expanded && job.POC && job.email ? "inline-block" : "none", fontWeight: "bold" }} className="job-description">&nbsp;at&nbsp;</p>
                                                        <a href={"mailto:" + job.email} style={{ display: job.expanded && job.POC && job.email ? "inline-block" : "none", fontWeight: "bold", color: "#3b74ec" }} className="job-description">{job.email}</a>
                                                        <br style={{ display: job.expanded ? "block" : "none" }} />

                                                        {job.expanded ?
                                                            <h className="job-btn"
                                                                onClick={() => this.expandJob(index)}>Hide Description</h> :
                                                            <h className="job-btn"
                                                                onClick={() => this.expandJob(index)}>View
                                                            Description and Apply >>>
                                                            </h>}

                                                    </td>
                                                </tr>)}
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
                <br /><br />
                <Footer />
            </div>
        )
    }
}

export default Jobs;